var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.info.bg_image)?_c('div',{staticClass:"floor-bgImg"},[_c('el-image',{staticStyle:{"width":"100%","height":"100%"},attrs:{"src":_vm.$img(_vm.info.bg_image),"fit":"fill"}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }